import React from 'react';
import { FunctionComponent, useCallback } from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../../app/dialog/dialog.actions';
import { dndBoardList } from '../../../../../../../app/page/page-storage/meeting-boards/meeting-boards.actions';
import { dndTask } from '../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { useScrollCancelDrag } from '../../../../../../../utils/useScrollCancelDrag';
import { IBoardListFormDialogProps } from '../../../../../../dialogs/BoardsDialogs/BoardListFormDialog/types';
import { BoardList } from './BoardList';
import { IBoardListsWrapperProps } from './types';

export const BoardListsWrapper: FunctionComponent<IBoardListsWrapperProps> = ({
  boardListIds,
  boardId,
  meetingId,
  unextendableBoard,
  isAdmin,
}) => {
  const dispatch = useDispatch();
  const { sensors, handleDragStart, handleDragEnd } = useScrollCancelDrag();

  const openBoardListFormDialog = useCallback(() => {
    dispatch(openDialog('boardListFormDialog', { boardId } as IBoardListFormDialogProps));
  }, [boardId, dispatch]);

  const handleDrop = useCallback(
    (result: DropResult) => {
      handleDragEnd();
      if (result.reason === 'CANCEL') {
        return;
      }
      if (result.type === 'column') {
        dispatch(dndBoardList(result, meetingId, boardId));
      } else {
        dispatch(dndTask(result, meetingId));
      }
    },
    [boardId, dispatch, meetingId, handleDragEnd],
  );

  return (
    <div className="cards-container-overflow">
      <div className="cards-container" style={{ height: '75vh', overflow: 'auto' }}>
        <DragDropContext sensors={sensors} onDragStart={handleDragStart} onDragEnd={handleDrop}>
          <Droppable droppableId={boardId} direction="horizontal" type="column">
            {(provided) => (
              <div style={{ display: 'flex', height: '75vh' }} {...provided.droppableProps} ref={provided.innerRef}>
                {boardListIds.map((boardListId, index) => (
                  <Draggable
                    key={`board-list-${boardListId}`}
                    draggableId={boardListId}
                    index={index}
                    isDragDisabled={!isAdmin}
                  >
                    {(provided) => (
                      <div
                        style={{ height: '100vh' }}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                      >
                        <BoardList boardListId={boardListId} meetingId={meetingId} />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {!unextendableBoard && (
          <div className="single-card-container">
            <div className="panel-body px-0">
              <div
                className="border-radius-1 lightGray-bg px-2 pb-1 py-5 gray-link popup_button"
                onClick={openBoardListFormDialog}
              >
                <div className="new_column p-5 flex flex-column aic jcc">
                  <span className="big-avatar blueGray-bg flex aic jcc">
                    <i className="icon-plus white f-4" />
                  </span>
                  <span className="blueGray mt-2">Add another list</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
